import React from 'react';
import { Box, TextField, LinearProgress, Typography, Alert } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StepNameAndDetailsProps } from '../types';

/**
 * Step 4: Name and details input
 * Displays URL (read-only in edit mode), name, and description fields
 * Shows processing progress bar
 */
export const StepNameAndDetails: React.FC<StepNameAndDetailsProps> = ({
  url,
  name,
  description,
  onChangeName,
  onChangeDescription,
  isProcessing,
  mode,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {mode === 'edit' && (
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="body2">
            {t('shareFolder.editMode.generalInfo')}
          </Typography>
        </Alert>
      )}

      <TextField
        fullWidth
        label={t('shareFolder.linkLabel')}
        value={url}
        disabled={mode === 'edit'}
        onChange={mode === 'create' ? (e) => onChangeName(e.target.value) : undefined}
        placeholder={t('shareFolder.linkPlaceholder')}
        sx={{ mb: 2 }}
        slotProps={{
          input: {
            startAdornment: <LinkIcon sx={{ mr: 1, color: 'text.secondary' }} />,
          },
        }}
        helperText={mode === 'edit' ? t('shareFolder.editMode.urlLocked') : undefined}
      />

      <TextField
        fullWidth
        label={t('shareFolder.importName')}
        value={name}
        onChange={(e) => onChangeName(e.target.value)}
        placeholder={t('shareFolder.importNamePlaceholder')}
        helperText={t('shareFolder.importNameHelper')}
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        multiline
        rows={2}
        label={t('shareFolder.descriptionLabel')}
        value={description}
        onChange={(e) => onChangeDescription(e.target.value)}
        placeholder={t('shareFolder.descriptionPlaceholder')}
        sx={{ mb: 2 }}
      />

      {isProcessing && (
        <Box sx={{ mb: 2 }}>
          <LinearProgress />
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            {mode === 'edit' ? t('shareFolder.updateInProgress') : t('shareFolder.importingMessage')}
          </Typography>
        </Box>
      )}
    </>
  );
};
